module.exports = __webpack_public_path__ + "static/media/Q12-7.bb66f6ed.jpg";